export function smoothScroll() {

    $(document).ready(function() {
        const $header = $('.l-header');
        const headerHeight = $header.length ? $header.outerHeight() : 0; // 一度だけ取得（offsetHeight相当）

        function smoothScroll(targetElement) {
            if (!targetElement.length) return;

            const $window = $(window);
            const startY = $window.scrollTop();
            const targetY = targetElement.offset().top - headerHeight;
            const duration = 1000;
            let startTime = null;

            function easeOutQuart(t) {
            return 1 - Math.pow(1 - t, 4);
            }

            function scroll(timestamp) {
            if (startTime === null) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeOutQuart(progress);
            const nextScroll = startY + (targetY - startY) * easedProgress;

            $window.scrollTop(nextScroll);

            if (progress < 1) {
                requestAnimationFrame(scroll);
            } else {
                $window.scrollTop(targetY);
                setTimeout(() => {
                history.replaceState(null, null, ' ');
                }, 0);
            }
            }

            requestAnimationFrame(scroll);
        }

        // ページロード時のハッシュ処理
        if (window.location.hash) {
            const $initialTarget = $(window.location.hash);
            if ($initialTarget.length) {
            setTimeout(() => {
                $(window).scrollTop($(window).scrollTop() - headerHeight);
                smoothScroll($initialTarget);
            }, 0);
            }
        }

        // リンククリック処理
        $('a[href^="#"], a[href*="#"]').on('click', function(e) {
            if (this.pathname === location.pathname) {
            e.preventDefault();
            const targetId = this.getAttribute('href').split('#')[1];
            const $targetElement = $('#' + targetId);
            smoothScroll($targetElement);
            }
        });
    });

}
